var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.serviceName === "Regulatory FAQs"
        ? [
            _c("p", {
              staticClass: "title text-emergo-dark-blue fw-500",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.sub_category) },
            }),
            _c("p", {
              staticClass:
                "description word-break mb-0 text-secondary fw-400 font-16",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.question) },
            }),
          ]
        : _vm.serviceName === "Regulations & Guidance"
        ? [
            _c("p", {
              staticClass: "title text-emergo-dark-blue fw-500",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.document_name) },
            }),
            _c("p", {
              staticClass:
                "description word-break mb-0 text-secondary fw-400 font-16",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.description) },
            }),
          ]
        : _vm.serviceName === "Regulatory Watch"
        ? [
            _c("p", {
              staticClass: "title text-emergo-dark-blue fw-500",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.title) },
            }),
            _c("p", {
              staticClass:
                "description word-break mb-0 text-secondary fw-400 font-16",
              domProps: { innerHTML: _vm._s(_vm.recordInfo.description) },
            }),
          ]
        : _vm.serviceName === "Regulatory Process Charts"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(_vm._s(_vm.recordInfo.name)),
            ]),
          ]
        : _vm.serviceName === "Government Fee Finder"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(" " + _vm._s(_vm.recordInfo.fee_name) + " "),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [_vm._v(" " + _vm._s(_vm.recordInfo.classification) + " ")]
            ),
          ]
        : _vm.serviceName === "Guides and Templates"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(" " + _vm._s(_vm.recordInfo.resource_name) + " "),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [_vm._v(" " + _vm._s(_vm.recordInfo.category_name) + " ")]
            ),
          ]
        : _vm.serviceName === "FDA Product Classification Lookup"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(" " + _vm._s(_vm.recordInfo.device_name) + " "),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [_vm._v(" " + _vm._s(_vm.recordInfo.product_code) + " ")]
            ),
          ]
        : _vm.serviceName === "510 (K) Review Time Calculator"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(" " + _vm._s(_vm.recordInfo.product_code) + " "),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.recordInfo.advisory_committee_description) +
                    " "
                ),
              ]
            ),
          ]
        : _vm.serviceName === "Marketplace"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(_vm._s(_vm.recordInfo.title)),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [_vm._v(" " + _vm._s(_vm.recordInfo.description) + " ")]
            ),
          ]
        : _vm.serviceName === "Regulatory Reports"
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.recordInfo.class_name) +
                  " - " +
                  _vm._s(_vm.recordInfo.artifact_name) +
                  " "
              ),
            ]),
            _c(
              "p",
              {
                staticClass:
                  "description word-break mb-0 text-secondary fw-400 font-16",
              },
              [_vm._v(" " + _vm._s(_vm.recordInfo.mapped_file) + " ")]
            ),
          ]
        : [
            "Agreements",
            "Product Tracker",
            "Records",
            "Notifications",
            "Dashboard",
            "Smart Builder",
            "Product Classification",
          ].includes(_vm.serviceName)
        ? [
            _c("p", { staticClass: "title text-emergo-dark-blue fw-500" }, [
              _vm._v(_vm._s(_vm.recordInfo.data)),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }